export const sellers = [
  {
    id: "LBIN256347",
    status: "Suspended",
    companyName: "Emayam Technologies",
    email: "contact1@emayam.com",
    assignedTo: ["Arun", "Kavi", "Surya"],
    phoneNumber: "6383516899"
  },
  {
    id: "LBIN256348",
    status: "Passive",
    companyName: "Zentech Pvt Ltd",
    email: "info@zentech.in",
    assignedTo: ["Deepa", "Naveen", "Raj"],
    phoneNumber: "9345112288"
  },
  {
    id: "LBIN256349",
    status: "Premium",
    companyName: "NeoTech Global",
    email: "support@neotech.com",
    assignedTo: ["Maya", "Prakash", "Lina"],
    phoneNumber: "7010554433"
  },
  {
    id: "LBIN256350",
    status: "Active",
    companyName: "InnovateX",
    email: "hello@innovatex.com",
    assignedTo: ["Ravi", "Divya", "Meena"],
    phoneNumber: "9966332211"
  },
  {
    id: "LBIN256351",
    status: "Deactive",
    companyName: "Bright Future Ltd",
    email: "bfuture@gmail.com",
    assignedTo: ["Vinoth", "Harsha", "Neha"],
    phoneNumber: "9088776655"
  },
  {
    id: "LBIN256352",
    status: "Suspended",
    companyName: "AmazeTech Solutions",
    email: "info@amazetech.in",
    assignedTo: ["Yash", "Nila", "Arav"],
    phoneNumber: "8233445566"
  },
  {
    id: "LBIN256353",
    status: "Active",
    companyName: "BrightHub",
    email: "hub@bright.com",
    assignedTo: ["Hari", "Megha", "Suriya"],
    phoneNumber: "9001122334"
  },
  {
    id: "LBIN256354",
    status: "Passive",
    companyName: "NextWave Tech",
    email: "nw@techwave.com",
    assignedTo: ["Ishaan", "Rekha", "Karthik"],
    phoneNumber: "9445566778"
  },
  {
    id: "LBIN256355",
    status: "Premium",
    companyName: "EcomSpark",
    email: "care@ecomspark.com",
    assignedTo: ["Pooja", "Ram", "Vimal"],
    phoneNumber: "9022114455"
  },
  {
    id: "LBIN256356",
    status: "Active",
    companyName: "GreenByte Ltd",
    email: "contact@greenbyte.org",
    assignedTo: ["Priya", "Santhosh", "Divya"],
    phoneNumber: "8110099008"
  },
  {
    id: "LBIN256357",
    status: "Suspended",
    companyName: "SkyNet Works",
    email: "admin@skynet.com",
    assignedTo: ["Aadhav", "Jeni", "Guru"],
    phoneNumber: "7355667788"
  },
  {
    id: "LBIN256358",
    status: "Deactive",
    companyName: "NovaEdge",
    email: "nova@edge.com",
    assignedTo: ["Rithika", "Saran", "Kavin"],
    phoneNumber: "7666223344"
  },
  {
    id: "LBIN256359",
    status: "Passive",
    companyName: "LogicRay",
    email: "lr@logics.com",
    assignedTo: ["Nandhini", "Ajay", "Devi"],
    phoneNumber: "7000111222"
  },
  {
    id: "LBIN256360",
    status: "Premium",
    companyName: "TechMount Inc",
    email: "contact@techmount.net",
    assignedTo: ["Manoj", "Shruthi", "Siva"],
    phoneNumber: "8300221133"
  },
  {
    id: "LBIN256361",
    status: "Active",
    companyName: "SmartCore Pvt",
    email: "smartcore@tech.com",
    assignedTo: ["Hariharan", "Sasi", "Priya"],
    phoneNumber: "9432233445"
  },
  {
    id: "LBIN256362",
    status: "Suspended",
    companyName: "TechNova",
    email: "info@technova.in",
    assignedTo: ["Rohit", "Ashwini", "Deepak"],
    phoneNumber: "7634567890"
  },
  {
    id: "LBIN256363",
    status: "Deactive",
    companyName: "OmniSoft",
    email: "omni@soft.com",
    assignedTo: ["Kaviya", "Senthil", "Gopi"],
    phoneNumber: "7988994433"
  },
  {
    id: "LBIN256364",
    status: "Premium",
    companyName: "BlueOcean Tech",
    email: "blue@ocean.com",
    assignedTo: ["Akhil", "Pavithra", "Lokesh"],
    phoneNumber: "9556677880"
  },
  {
    id: "LBIN256365",
    status: "Active",
    companyName: "RedDot Innovations",
    email: "reddot@innov.com",
    assignedTo: ["Meera", "Suraj", "Nithin"],
    phoneNumber: "8099223344"
  },
  {
    id: "LBIN256366",
    status: "Passive",
    companyName: "NeoSolutions",
    email: "neo@solutions.in",
    assignedTo: ["Sahana", "Ashok", "Vidhya"],
    phoneNumber: "7233445599"
  }
];
